import { helper } from '@ember/component/helper';

// Originally used https://github.com/kellysutton/ember-number-to-human-size
// for this but it hasn't been kept up to date and doesn't play well with
// Ember updates. The add-on realy only provides this one function, so it's
// easier to manage upgrades if we just maintain this code.
export default helper(function numberToHuman(params /*, named*/) {
  let bytes = params[0];
  let si = !params[1];
  let roundAmount = params[2] || 0;
  let thresh = si ? 1000 : 1024;
  let u = -1;
  let units = si ?
    ['kB','MB','GB','TB','PB','EB','ZB','YB'] :
    ['KiB','MiB','GiB','TiB','PiB','EiB','ZiB','YiB'];

  if (Math.abs(bytes) < thresh) {
    return `${bytes} B`;
  }

  do {
    bytes /= thresh;
    ++u;
  } while(Math.abs(bytes) >= thresh && u < units.length - 1);

  return `${bytes.toFixed(roundAmount)} ${units[u]}`;
});
